<template>
  <div class="flex flex-col relative notification-wrap" @click="click">
    <van-image :src="notification.eventCoverImage" fit="cover" show-loading :height="height">
      <template v-slot:loading>
        <van-loading type="spinner" size="50"/>
      </template>
    </van-image>
    <div class="pt-2.5 pb-2.5 pl-3 pr-3">

      <span class="title">{{ notification.eventName }}</span>
      <div class="flex flex-row items-center justify-between mt-4" style="font-size:12px;">
        <span class="main-color">{{ notification.nickName }}</span>
        <span class="third-color">{{ notification.startTime }}</span>
      </div>
    </div>
    <div v-if="showStatus" :class="notification.eventStatus === 0 ? 'on': 'end'">
      {{ notification.eventStatus === 0 ? "ON" : "OFF" }}
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationItem",
  props: {
    notification: {
      type: Object,
      required: true
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    height: {
      type:Number,
      default: 170
    }
  },
  data() {
    return {
      itemWidth: 0
    };
  },
  methods: {
    click() {
      this.$emit("click");
    }
  },
  mounted() {
    this.itemWidth = `${(document.body.clientWidth - 48) / 2}px`;
    console.log(`item width = ${this.itemWidth}`);
  }
};
</script>

<style scoped lang="less">
.notification-wrap {
  border-radius: 12px;
  background: white;
}

::v-deep .van-image {
  img {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px
  }
}

.title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-weight: 500;
  font-size: 18px;
  text-align: start;
}

.on {
  position: absolute;
  right: 12px;
  top: 12px;
  width: 45px;
  height: 20px;
  background: #F1F6FF;
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
}

.end {
  position: absolute;
  right: 12px;
  top: 12px;
  right: 12px;
  top: 12px;
  width: 45px;
  height: 20px;
  background: #E8E8E8;
  color: #999999;
  font-size: 12px;
  border-radius: 4px;
  text-align: center;
}
</style>